import {
  colorFacetsNeutralDark400,
  colorFacetsNeutralLight200,
  colorFacetsRed500,
} from '@netlify/netlify-design-tokens'
import { Badge, Button, Card, Paragraph, Text } from 'evergreen-ui'

import { SymbolCircleIcon } from '~/icons/evergreen'
import { useActions, useStore } from '~/store/hooks'

export default function HeadsUpNotifications() {
  const notifications = useStore(state => state.notifications.items)
  const expunge = useActions(action => action.notifications.expunge)

  const sortedNotifications = notifications.sort((a, b) => (a.priority > b.priority ? -1 : 1))
  const notification = sortedNotifications[0] || {}

  if (notifications.length === 0) {
    return null
  }

  const { action, cta, intent, message, pulse, type } = notification
  return (
    <Card
      background={intent === 'badge' ? 'rgb(var(--colorRgbFacetsGreen000) / 40%)' : 'rgba(0, 0, 0, 0.05)'}
      borderRadius={6}
      className="is-hidden-mobile"
      // cursor="pointer"
      marginLeft={8}
      opacity={notifications.length ? 1 : 0}
      overflow="hidden"
      paddingLeft={8}
      // paddingY={2}
      transform={`translateY(${notifications.length ? 0 : 32}px)`}
      transition="opacity 300ms ease, transform 300ms ease"
    >
      <Paragraph alignItems="center" display="flex">
        {intent === 'dot' && (
          <SymbolCircleIcon
            className={pulse ? 'pulsing' : undefined}
            color={colorFacetsRed500}
            marginRight={8}
            size={12}
          />
        )}
        {intent === 'badge' && (
          <Badge color="green" marginRight={8}>
            New
          </Badge>
        )}
        <Text
          color={colorFacetsNeutralDark400}
          display="block"
          fontSize={13}
          marginRight={cta ? undefined : 8}
          maxWidth={300}
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {message}
        </Text>
        {cta && (
          <Button
            appearance="minimal"
            borderLeftColor={colorFacetsNeutralLight200}
            borderLeftStyle="solid"
            borderLeftWidth={1}
            borderRadius={0}
            className="hun-cta"
            marginLeft={8}
            onClick={e => {
              if (action) {
                action()
              }
              expunge(type)
              e.stopPropagation()
            }}
            paddingY={3}
            size="small"
          >
            {cta}
          </Button>
        )}
      </Paragraph>
    </Card>
  )
}
